import { all, call, takeEvery } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { getAllFabricOptionsResponse, getFabricOptionByIdResponse } from "../actions";
import { axiosPost } from "../../utils/common/axios";
import { today } from "../../constants/garmentCodes";
import { createEntitySagas, extractPayloadAndCallback, runOptimisticAction, selectUserId, toQuery } from "./sagaHelpers";

export const fabricOptionEntity = createEntitySagas({
  entity: "fabricoption",
  endpoint: "fabric-options",
  label: "Fabric option",
  scope: "company",
  computedFields: ["brandName", "manufacturerName", "requirementName"],
  selectSlice: (state) => state.fabricoption,
  listKey: "options",
  types: {
    getAll: types.GET_ALL_FABRIC_OPTIONS,
    getById: types.GET_FABRIC_OPTION_BY_ID,
    create: types.CREATE_FABRIC_OPTION,
    update: types.UPDATE_FABRIC_OPTION,
    remove: types.DELETE_FABRIC_OPTION,
  },
  actions: { getAllResponse: getAllFabricOptionsResponse, getByIdResponse: getFabricOptionByIdResponse },
});

// payload: { id, decisionStatus, approvalNote }
function* approveSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, decisionStatus, approvalNote } = payload;
  const approvedByUserId = yield* selectUserId(payload);
  yield* runOptimisticAction({
    entity: "fabricoption",
    selectList: fabricOptionEntity.selectList,
    id,
    changes: { decisionStatus, approvalNote, approvedByUserId, approvedDate: today() },
    request: () => axiosPost(`fabric-options/${id}/approve${toQuery({ decisionStatus, approvedByUserId, approvalNote })}`),
    successMessage: "Fabric option approved",
    errorFallback: "Could not approve fabric option",
    callback,
  });
}

// payload: { id, decisionStatus, rejectionReason }
function* rejectSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, decisionStatus, rejectionReason } = payload;
  const rejectedByUserId = yield* selectUserId(payload);
  yield* runOptimisticAction({
    entity: "fabricoption",
    selectList: fabricOptionEntity.selectList,
    id,
    changes: { decisionStatus, rejectionReason, rejectedByUserId, rejectedDate: today() },
    request: () => axiosPost(`fabric-options/${id}/reject${toQuery({ decisionStatus, rejectedByUserId, rejectionReason })}`),
    successMessage: "Fabric option rejected",
    errorFallback: "Could not reject fabric option",
    callback,
  });
}

export function* fabricoptionSaga() {
  yield all([
    call(fabricOptionEntity.watcher),
    takeEvery(types.APPROVE_FABRIC_OPTION, approveSaga),
    takeEvery(types.REJECT_FABRIC_OPTION, rejectSaga),
  ]);
}
